<template>
    <transition name="modal">
        <div class="modal-mask" @click.self="close">
            <div class="modal-wrapper">
                <div class="card mb-0">
                    <div class="card-body">
                        <label for="parameterName">{{ 'audit.search.parameterName' | lang }}</label>
                        <form @submit="setParameter">
                            <div class="form-group">
                                <select v-model="parameterKey" class="form-control text-capitalize" id="parameterName" @change="onParameterSelect">
                                    <option value="" disabled hidden>{{ 'audit.search.select' | lang }}</option>
                                    <option v-for="(value, name) in properties" class="text-capitalize" :value="name"
                                            :hidden="!isSelectable(name)" >
                                        {{ name.replace(/_/g,' ') }}
                                    </option>
                                </select>
                            </div>
                            <template v-if="parameterKey">
                                <div class="form-group mb-0">
                                    <label for="parameterValue">{{ 'audit.search.parameterValue' | lang }}</label>
                                    <input class="form-control" ref="valueInput" v-model="parameterValue" id="parameterValue"
                                           :placeholder="properties.get(parameterKey)" autocomplete="off">
                                    <button class="btn btn-secondary btn-block btn-sm mt-3"
                                            :disabled="properties.compare(parameterKey, parameterValue) || parameterValue === null"
                                            type="submit">
                                        {{ 'audit.search.submit' | lang }}
                                    </button>
                                </div>
                            </template>
                        </form>
                        <button class="btn btn-secondary btn-block btn-sm mt-3" @click="close">
                            {{ 'audit.search.close' | lang }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
  import AuditParameters from "./AuditParameters";

  export default {
    name: "AuditsModal",
    props: {
      properties: AuditParameters,
      selected: String,
    },
    data() {
      return {
        showModal: false,
        parameterKey: '',
        parameterValue: null,
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      isSelectable(propertyKey) {
        return this.$parent.isSelectable([propertyKey]);
      },
      setParameter(e) {
        this.$parent.select({[this.parameterKey]: this.parameterValue});
        this.parameterValue = null;

        e.preventDefault();
        this.close();
      },
      onParameterSelect() {
        if (this.parameterKey) {
          this.$nextTick(() => this.$refs.valueInput.focus())
        }
      }
    },
    mounted() {
      this.parameterKey = this.selected;
      this.onParameterSelect();
    }
  }
</script>

<style scoped>

</style>